import {
  fetchProtocolScene,
  PROTOCOL_SLIDE_TYPES,
  SLIDE_GROUP,
  checkIfNodeComplete,
} from '@learningblocks/protocol-constants/lib/Utilities';
import {updateSlideInList, setNewCurrentNode} from '../../utilities';

export function slideTwoSelectPath(state, payload) {
  return {
    ...state,
    protocolSection: updateDesignSection(state.protocolSection, payload),
  };
}

function updateDesignSection(protocolSection, payload) {
  const allSlides = updateAllSlides(protocolSection.allSlides, payload);
  return {
    ...protocolSection,
    allSlides,
  };
}

function updateAllSlides(allSlides, payload) {
  const slideTwo = fetchProtocolScene(allSlides, PROTOCOL_SLIDE_TYPES.TWO);
  const designSlideTwo = updateSelectionInSlideTwo(slideTwo, payload);
  const updatedAllSlides = updateSlideInList(allSlides, designSlideTwo);
  return updatedAllSlides;
}

function updateSelectionInSlideTwo(slideTwo, payload) {
  const updateOption = (option) => {
    if (option.id === payload.componentID) {
      option.selected = true;
    } else {
      option.selected = false;
    }
    return {...option};
  };
  const updateSelectionInNode = (node) => {
    node.nodeOptions = node.nodeOptions.map(updateOption);
    if (node.nodeComponent !== payload.componentID) {
      incorrects += 1;
    }
    return {...node};
  };

  const updateAllNodes = (node) => {
    if (node.nodeId === payload.nodeId) {
      node = updateSelectionInNode(node);
    }
    return {...node};
  };

  const updatedTreeGroup = (treeGroup) => {
    const groupNodes = treeGroup.groupNodes.map(updateAllNodes);
    let groupComplete = false;
    if (treeGroup.groupType === SLIDE_GROUP.JOINT_GROUP_SEQUENCE) {
      groupComplete = isGroupComplete(treeGroup.groupNodes);
    }
    return {
      ...treeGroup,
      groupNodes,
      groupComplete,
    };
  };

  let {incorrects} = slideTwo;
  let slideTree = slideTwo.slideTree.map(updatedTreeGroup);
  slideTree = setNewCurrentNode(slideTree);
  return {
    ...slideTwo,
    incorrects,
    slideTree,
  };
}

function isGroupComplete(groupNodes) {
  return groupNodes.every((groupNode) => checkIfNodeComplete(groupNode));
}
